<script setup lang="ts">
import type { DialogRootEmits, DialogRootProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { useForwardPropsEmits } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '#ui-kit/ui/dialog'
import Command from './Command.vue'

const props = defineProps<
  DialogRootProps & {
    title: string
    description?: string
    contentClass?: HTMLAttributes['class']
    commandClass?: HTMLAttributes['class']
  }
>()

const emits = defineEmits<DialogRootEmits>()

const delegatedProps = reactiveOmit(props, 'title', 'description', 'contentClass', 'commandClass')

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <Dialog v-bind="forwarded">
    <DialogContent
      :class="cn('overflow-hidden p-0 shadow-lg', contentClass)"
      v-bind="description ? {} : { 'aria-describedby': undefined }"
    >
      <DialogTitle class="sr-only">{{ title }}</DialogTitle>
      <DialogDescription v-if="description" class="sr-only">{{ description }}</DialogDescription>
      <Command :class="commandClass">
        <slot />
      </Command>
    </DialogContent>
  </Dialog>
</template>
